import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import isWeekend from 'date-fns/isWeekend'
import addMonths from 'date-fns/addMonths'
import addBusinessDays from 'date-fns/addBusinessDays'

const dateFormats = {
  DATE_FORMAT_ISO: 'yyyy-MM-dd',
  DATE_FORMAT: 'dd MMMM',
  DATE_TIME_FORMAT: 'dd MMMM HH:mm',
  TIME_FORMAT: 'HH:mm',
  DATE_TIME_FORMAT_FULL: 'YYYY-MM-DDTHH:mm:ss.sss'
}

const parse = (date: Date | string) => {
  return typeof date === 'string' ? parseISO(date) : date
}

const safeFormat = (date: Date, formatting: string) => {
  return format(date, formatting)
}

export const formatDateIso = (date: Date | string) => {
  return safeFormat(parse(date), dateFormats.DATE_FORMAT_ISO)
}

export const operatorChangeDateOptions = {
  disable: [(date: Date) => isWeekend(date)],
  minDate: addBusinessDays(new Date(), 6),
  maxDate: addMonths(new Date(), 3)
}
